import { render, staticRenderFns } from "./region-card.vue?vue&type=template&id=4a000682&"
import script from "./region-card.vue?vue&type=script&lang=js&"
export * from "./region-card.vue?vue&type=script&lang=js&"
import style0 from "./region-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a000682')) {
      api.createRecord('4a000682', component.options)
    } else {
      api.reload('4a000682', component.options)
    }
    module.hot.accept("./region-card.vue?vue&type=template&id=4a000682&", function () {
      api.rerender('4a000682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/@fragment/region-card.vue"
export default component.exports